import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FaGift, FaIdCard, FaFacebookF, FaInstagram } from 'react-icons/fa'

import CarouselElement from "../elements/CarouselElement"
import UltimasNoticias from './UltimasNoticias'
import JornalCTA from './JornalCTA'

import imagemFimEscala6x1 from '../assets/images/fim-da-escala-6x1.png';

function Inicio() {
  const data = {
    images: [
      { name: 'noticias_1_001.jpg' },
      { name: 'noticias_1_002.jpg' },
      { name: 'noticias_1_003.jpg' },
    ]
  }
  return (
    <>
      <Container>
        <CarouselElement data={data} />
      </Container>

      {/* ── Atalhos rápidos ── */}
      <div className="inicio-atalhos mt-3">
        <Container>
          <Row className="g-0">

            {/* Benefícios */}
            <Col xs={12} md={4}>
              <Link to="/beneficios" className="inicio-atalho-item inicio-atalho-beneficios">
                <span className="inicio-atalho-icon"><FaGift /></span>
                <div>
                  <p className="inicio-atalho-label">Convênios e descontos exclusivos</p>
                  <h3 className="inicio-atalho-title">Benefícios</h3>
                </div>
                <span className="inicio-atalho-arrow">→</span>
              </Link>
            </Col>

            {/* Associe-se */}
            <Col xs={12} md={4}>
              <Link to="/associe-se" className="inicio-atalho-item inicio-atalho-associe">
                <span className="inicio-atalho-icon"><FaIdCard /></span>
                <div>
                  <p className="inicio-atalho-label">Faça parte do sindicato</p>
                  <h3 className="inicio-atalho-title">Associe-se</h3>
                </div>
                <span className="inicio-atalho-arrow">→</span>
              </Link>
            </Col>

            {/* Redes sociais */}
            <Col xs={12} md={4}>
              <div className="inicio-atalho-item inicio-atalho-social">
                <div>
                  <p className="inicio-atalho-label">Acompanhe as novidades</p>
                  <h3 className="inicio-atalho-title">Redes Sociais</h3>
                  <div className="inicio-social-links">
                    <a
                      href="https://www.facebook.com/smetalbauru"
                      target="_blank"
                      rel="noreferrer"
                      className="inicio-social-btn inicio-social-facebook"
                      aria-label="Facebook"
                    >
                      <FaFacebookF /> Facebook
                    </a>
                    <a
                      href="https://www.instagram.com/metalbauru"
                      target="_blank"
                      rel="noreferrer"
                      className="inicio-social-btn inicio-social-instagram"
                      aria-label="Instagram"
                    >
                      <FaInstagram /> Instagram
                    </a>
                  </div>
                </div>
              </div>
            </Col>

          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col xs={12} lg={3}>
            <Row className="mt-3">
              <Col xs={12}>
                <h2 className="section-title">Fim da Escala 6x1</h2>
              </Col>
              <Col xs={12}>
                <a href="/fim-da-escala-6x1" className="fim-escala-card-link">
                  <img
                    src={imagemFimEscala6x1}
                    alt="Fim da Escala 6x1"
                    className="news-card-image"
                  />
                </a>
              </Col>
            </Row>
          </Col>
          <Col xs={12} lg={9}>
            <UltimasNoticias />
          </Col>
        </Row>
      </Container>

      <Container fluid className='jornal-cta'>
        <JornalCTA />
      </Container>
    </>
  )
}

export default Inicio